import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepChooseStation,
  StepError,
  StepFinished,
  StepLogin,
  StepVerifyCode,
} from "../../steps";

export const LandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <main className="landing-outside-container">
      <div className="landing-container">
        <button
          type="button"
          className="landing-logo"
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          aria-label="Go to homepage"
        />

        {(!step || step === LandingStepEnum.LoginStep) && <StepLogin />}
        {step === LandingStepEnum.VerificationStep && <StepVerifyCode />}
        {step === LandingStepEnum.ChooseStationStep && <StepChooseStation />}
        {step === LandingStepEnum.FinishedStep && <StepFinished />}
        {step === LandingStepEnum.ErrorStep && <StepError />}
      </div>
    </main>
  );
};
